import React, { useEffect, useRef, useState } from 'react'
import { CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import * as workerTimers from 'worker-timers'

import { getTimeInMinutesAndSecs } from '@nw/shared/utils'

interface CircularProgressBarProps {
  totalTimeInSeconds: number
  onComplete: () => void
}

const CircularProgressBar = (props: CircularProgressBarProps) => {
  const { totalTimeInSeconds, onComplete } = props
  const [currentPercentage, setCurrentPercentage] = useState(100)
  const seconds = useRef(totalTimeInSeconds)
  const timerId = useRef(null)

  useEffect(() => {
    timerId.current = workerTimers.setInterval(setSeconds, 1000)
    return () => {
      clearTimeInterval()
    }
  }, [totalTimeInSeconds])

  const clearTimeInterval = (): void => {
    if (timerId?.current) {
      workerTimers.clearInterval(timerId.current)
      timerId.current = null
    }
  }

  const updateCurrentPercentage = (): void => {
    setCurrentPercentage((seconds.current / totalTimeInSeconds) * 100)
  }

  const isTimeCompleted = (): void => {
    if (seconds.current === 0) {
      onComplete()
      clearTimeInterval()
    }
  }

  const setSeconds = (): void => {
    if (seconds.current !== 0) {
      seconds.current = seconds.current - 1
    }
    updateCurrentPercentage()
    isTimeCompleted()
  }

  const customStyles = {
    path: {
      stroke: '#2563EB'
    },
    text: {
      fill: '#2563EB',
      fontSize: '18px',
      fontWeight: '600'
    },
    trail: {
      stroke: '#F1F5F9'
    }
  }

  return (
    <CircularProgressbar
      value={currentPercentage}
      text={getTimeInMinutesAndSecs(Math.max(seconds.current, 0))}
      styles={customStyles}
    />
  )
}

export default CircularProgressBar
